__webpack_require__.p = "https://assets.ginkonote.com/assets/";